<template>
    <footer class="modern-footer">
        <!-- Main Footer Content -->
        <div class="footer-main">
            <b-container>
                <b-row>
                    <!-- Company Info Column -->
                    <b-col lg="6" md="6" class="footer-column mb-4 mb-lg-0">
                        <div class="footer-brand">
                            <img 
                                class="footer-logo" 
                                height="75px" 
                                alt="Chill Byte logo"
                                src="../../assets/LogoFigure PNG.png" 
                            />
                            <p class="footer-description">
                                Transformamos ideas en soluciones digitales innovadoras. Tu socio tecnológico para llevar proyectos al siguiente nivel.
                            </p>
                            <!-- Social Links -->
                            <div class="footer-social">
                                <a 
                                    href="https://www.instagram.com/chill.byte/" 
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    class="social-icon instagram"
                                    aria-label="Instagram"
                                >
                                    <font-awesome-icon icon="fa-brands fa-instagram" />
                                </a>
                                <a 
                                    href="https://www.facebook.com/profile.php?id=100095394246867" 
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    class="social-icon facebook"
                                    aria-label="Facebook"
                                >
                                    <font-awesome-icon icon="fa-brands fa-facebook" />
                                </a>
                                <a 
                                    href="https://wa.me/5214423336440" 
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    class="social-icon whatsapp"
                                    aria-label="WhatsApp"
                                >
                                    <font-awesome-icon icon="fa-brands fa-whatsapp" />
                                </a>
                            </div>
                        </div>
                    </b-col>

                    <!-- Contact Column -->
                    <b-col lg="6" md="6" class="footer-column">
                        <h4 class="footer-title">Contacto</h4>
                        <ul class="footer-contact">
                            <li>
                                <div class="contact-item">
                                    <font-awesome-icon icon="fa-brands fa-whatsapp" class="contact-icon" />
                                    <a href="https://wa.me/5214423336440" target="_blank">442 333 6440</a>
                                </div>
                            </li>
                            <li>
                                <div class="contact-item">
                                    <font-awesome-icon icon="fa-regular fa-envelope" class="contact-icon" />
                                    <a href="mailto:info@chillbytesolutions.com">info@chillbytesolutions.com</a>
                                </div>
                            </li>
                            <li>
                                <div class="contact-item">
                                    <font-awesome-icon icon="fa-solid fa-location-dot" class="contact-icon" />
                                    <span>Querétaro, México</span>
                                </div>
                            </li>
                        </ul>
                        <!-- CTA Button -->
                        <router-link to="/contacto" class="footer-cta-btn">
                            ¡Hablemos de tu proyecto!
                            <font-awesome-icon icon="fa-solid fa-arrow-right" class="arrow-icon" />
                        </router-link>
                    </b-col>
                </b-row>
            </b-container>
        </div>

        <!-- Footer Bottom -->
        <div class="footer-bottom">
            <b-container>
                <div class="footer-bottom-content">
                    <p class="copyright">
                        &copy; {{ currentYear }} Chill Byte Solutions. Todos los derechos reservados.
                    </p>
                    <div class="footer-bottom-links">
                        <router-link to="/politica-privacidad">Política de Privacidad</router-link>
                        <!-- <span class="separator">|</span>
                        <router-link to="/terminos">Términos de Servicio</router-link> -->
                    </div>
                </div>
            </b-container>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'FooterComponent',
    data() {
        return {
            currentYear: new Date().getFullYear()
        }
    }
}
</script>

<style scoped lang="scss">
$purple: #8C52FF;
$blue: #3f84e5;
$corporateNavy: #1e1b4b;
$corporateTeal: #3e92cc;
$darkGray: #334155;
$mediumGray: #e2e8f0;
$lightGray: #f8fafc;
$white: #fdfdfd;

.modern-footer {
    font-family: 'Inter', sans-serif;
    background: linear-gradient(135deg, #0a2463 0%, #1e3a8a 100%);
    color: $white;
    position: relative;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: radial-gradient(circle at 20% 50%, rgba(140, 82, 255, 0.15) 0%, transparent 50%),
                    radial-gradient(circle at 80% 80%, rgba(62, 146, 204, 0.1) 0%, transparent 50%);
        pointer-events: none;
    }
}

.footer-main {
    padding: 80px 0 50px;
    position: relative;
    z-index: 1;

    @media (max-width: 992px) {
        padding: 60px 0 40px;
    }
}

.footer-column {
    position: relative;
    z-index: 1;
}

.footer-brand {
    .footer-logo {
        margin-bottom: 20px;
        filter: brightness(1.1);
    }

    .footer-description {
        font-size: 0.95rem;
        line-height: 1.7;
        color: rgba(255, 255, 255, 0.85);
        margin-bottom: 25px;
        max-width: 90%;
    }
}

.footer-social {
    display: flex;
    gap: 12px;
    margin-top: 25px;

    .social-icon {
        width: 42px;
        height: 42px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255, 255, 255, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.2);
        color: $white;
        font-size: 1.2rem;
        transition: all 0.3s ease;
        backdrop-filter: blur(10px);

        &:hover {
            transform: translateY(-3px);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
        }

        &.instagram:hover {
            background: linear-gradient(135deg, #833ab4 0%, #fd1d1d 50%, #fcb045 100%);
            border-color: transparent;
        }

        &.facebook:hover {
            background: #1877f2;
            border-color: transparent;
        }

        &.whatsapp:hover {
            background: #25d366;
            border-color: transparent;
        }
    }
}

.footer-title {
    font-family: 'Inter', sans-serif;
    font-size: 1.1rem;
    font-weight: 700;
    color: $white;
    margin-bottom: 25px;
    text-transform: uppercase;
    letter-spacing: 1px;
    position: relative;
    padding-bottom: 12px;

    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 40px;
        height: 3px;
        background: linear-gradient(90deg, $purple 0%, $corporateTeal 100%);
        border-radius: 2px;
    }
}

.footer-links {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
        margin-bottom: 12px;

        a {
            color: rgba(255, 255, 255, 0.8);
            text-decoration: none;
            font-size: 0.95rem;
            font-weight: 500;
            transition: all 0.3s ease;
            display: inline-block;
            position: relative;

            &::before {
                content: '';
                position: absolute;
                bottom: -2px;
                left: 0;
                width: 0;
                height: 2px;
                background: linear-gradient(90deg, $purple 0%, $corporateTeal 100%);
                transition: width 0.3s ease;
            }

            &:hover {
                color: $white;
                padding-left: 8px;

                &::before {
                    width: 100%;
                }
            }
        }
    }
}

.footer-contact {
    list-style: none;
    padding: 0;
    margin: 0 0 25px 0;

    li {
        margin-bottom: 16px;
    }

    .contact-item {
        display: flex;
        align-items: center;
        gap: 12px;
        font-size: 0.95rem;

        .contact-icon {
            width: 20px;
            color: $purple;
            font-size: 1.1rem;
        }

        a {
            color: rgba(255, 255, 255, 0.85);
            text-decoration: none;
            transition: all 0.3s ease;
            font-weight: 500;

            &:hover {
                color: $white;
                text-decoration: underline;
            }
        }

        span {
            color: rgba(255, 255, 255, 0.85);
            font-weight: 500;
        }
    }
}

.footer-cta-btn {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 12px 24px;
    background: linear-gradient(135deg, $purple 0%, #6366f1 100%);
    color: $white;
    font-weight: 600;
    font-size: 0.95rem;
    border-radius: 8px;
    text-decoration: none;
    transition: all 0.3s ease;
    box-shadow: 0 8px 20px rgba(140, 82, 255, 0.3);
    margin-top: 10px;

    .arrow-icon {
        transition: transform 0.3s ease;
        font-size: 0.9rem;
    }

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 12px 28px rgba(140, 82, 255, 0.4);
        text-decoration: none;
        color: $white;

        .arrow-icon {
            transform: translateX(5px);
        }
    }
}

.footer-bottom {
    border-top: 1px solid rgba(255, 255, 255, 0.15);
    padding: 25px 0;
    position: relative;
    z-index: 1;

    .footer-bottom-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 15px;

        @media (max-width: 768px) {
            flex-direction: column;
            text-align: center;
        }

        .copyright {
            margin: 0;
            color: rgba(255, 255, 255, 0.7);
            font-size: 0.9rem;
            font-weight: 500;
        }

        .footer-bottom-links {
            display: flex;
            align-items: center;
            gap: 15px;
            flex-wrap: wrap;

            a {
                color: rgba(255, 255, 255, 0.7);
                text-decoration: none;
                font-size: 0.9rem;
                font-weight: 500;
                transition: color 0.3s ease;

                &:hover {
                    color: $white;
                    text-decoration: underline;
                }
            }

            .separator {
                color: rgba(255, 255, 255, 0.4);
            }
        }
    }
}

@media (max-width: 768px) {
    .footer-brand {
        text-align: center;

        .footer-logo {
            margin-left: auto;
            margin-right: auto;
            display: block;
        }

        .footer-description {
            max-width: 100%;
        }

        .footer-social {
            justify-content: center;
        }
    }

    .footer-title {
        text-align: center;

        &::after {
            left: 50%;
            transform: translateX(-50%);
        }
    }

    .footer-links {
        text-align: center;
    }

    .footer-contact {
        text-align: center;

        .contact-item {
            justify-content: center;
        }
    }

    .footer-cta-btn {
        display: flex;
        justify-content: center;
        width: 100%;
        max-width: 300px;
        margin-left: auto;
        margin-right: auto;
    }
}
</style>